"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawPaintObject = void 0;
var tslib_1 = require("tslib");
var drawPaintObject = function (pixel, paintObject, _a, pixelAt) {
    var _b = tslib_1.__read(_a, 4), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
    var _c = paintObject.bitMatrix, width = _c.width, height = _c.height, data = _c.data;
    var top = paintObject.pixelTop;
    var left = paintObject.pixelLeft;
    var at = function (x, y) { return y * width + x; };
    for (var j = 0; j < height; ++j) {
        for (var i = 0; i < width; ++i) {
            if (data.get(at(i, j), 0) > 0) {
                pixel.data[pixelAt(i + left, j + top)] = r;
                pixel.data[pixelAt(i + left, j + top) + 1] = g;
                pixel.data[pixelAt(i + left, j + top) + 2] = b;
                pixel.data[pixelAt(i + left, j + top) + 3] = a * 255;
            }
        }
    }
};
exports.drawPaintObject = drawPaintObject;
